(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.getElementById('menu-toggle');
    const navOverlay = document.getElementById('nav-overlay');
    const navClose = document.getElementById('nav-close');

    // Open overlay
    menuToggle.addEventListener('click', function() {
      navOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    });

    // Close overlay
    navClose.addEventListener('click', function() {
      navOverlay.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    });

    // Close overlay when clicking outside the content
    navOverlay.addEventListener('click', function(e) {
      if (e.target === navOverlay) {
        navOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });

    // Close overlay on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && navOverlay.classList.contains('active')) {
        navOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-mega-variant"]) return;
  try {
    
  // Helper function to update cart count in header
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElement = document.getElementById('cart-count');
        if (cartCountElement) {
          cartCountElement.textContent = cart.item_count;
          if (cart.item_count > 0) {
            cartCountElement.style.display = '';
          } else {
            cartCountElement.style.display = 'none';
          }
        }
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  class MegaVariantSelector {
    constructor() {
      this.variantSelect = document.getElementById('variantSelect');
      this.priceElement = document.getElementById('variantPrice');
      this.addToCartButton = document.getElementById('addToCartButton');
      this.variantImagesContainer = document.getElementById('variantImages');
      this.seeAllOption = this.variantSelect?.querySelector('.see-all-option');
      this.selectColorOption = this.variantSelect?.querySelector('.select-color-option');
      this.allProductImages = this.getAllProductImages();
      this.processingButtons = new Set(); // Track which buttons are currently processing

      this.searchToggle = document.getElementById('variantSearchToggle');
      this.searchContainer = document.getElementById('variantSearchContainer');
      this.searchInput = document.getElementById('variantSearchInput');
      this.searchResults = document.getElementById('variantSearchResults');

      if (this.variantSelect) {
        this.init();
      }
    }

    getAllProductImages() {
      // Store initial state of all product images
      const images = [];
      if (this.variantImagesContainer) {
        const imageElements = this.variantImagesContainer.querySelectorAll('.product-image');
        imageElements.forEach(img => {
          images.push({
            html: img.outerHTML
          });
        });
      }
      return images;
    }

    init() {
      this.variantSelect.addEventListener('change', (e) => {
        this.handleVariantChange(e.target.value);
      });

      // Search toggle
      if (this.searchToggle) {
        this.searchToggle.addEventListener('click', () => this.toggleSearch());
      }
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => this.handleSearch());
        this.searchInput.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closeSearch();
        });
      }
      // Close search when clicking outside
      document.addEventListener('click', (e) => {
        if (this.searchContainer && !this.searchContainer.contains(e.target) &&
            !this.searchToggle.contains(e.target)) {
          this.closeSearch();
        }
      });

      // Check if a variant is already selected (e.g., browser back button)
      const selectedVariantId = this.variantSelect.value;

      if (selectedVariantId && selectedVariantId !== '' && selectedVariantId !== 'see-all') {
        // A variant is pre-selected, trigger the change to update UI
        this.handleVariantChange(selectedVariantId);
      } else {
        // No variant selected on initial load
        if (this.addToCartButton) {
          this.addToCartButton.disabled = true;
          this.addToCartButton.textContent = 'Add to Cart';
        }

        // Price range is already showing from Liquid, no need to hide
      }
    }

    handleVariantChange(variantId) {
      // Handle "See all colors" or empty selection
      if (!variantId || variantId === 'see-all') {
        this.resetToAllImages();
        return;
      }

      const variant = window.productVariants[variantId];

      if (!variant) return;

      // Update price and show it
      if (this.priceElement) {
        this.priceElement.textContent = variant.price;
        this.priceElement.style.display = 'block';
      }

      // Update button state
      if (this.addToCartButton) {
        if (variant.available) {
          this.addToCartButton.disabled = false;
          this.addToCartButton.textContent = 'Add to Cart';
        } else {
          this.addToCartButton.disabled = true;
          this.addToCartButton.textContent = 'Sold Out';
        }
      }

      // Hide "Select a color" and show "See all colors" option
      if (this.selectColorOption) {
        this.selectColorOption.classList.add('hidden');
        this.selectColorOption.style.display = 'none';
      }
      if (this.seeAllOption) {
        this.seeAllOption.classList.remove('hidden');
        this.seeAllOption.style.display = 'block';
      }

      // Swap variant images
      this.swapVariantImages(variantId);
    }

    toggleSearch() {
      if (!this.searchContainer) return;
      const isHidden = this.searchContainer.classList.contains('hidden');
      if (isHidden) {
        this.searchContainer.classList.remove('hidden');
        this.searchToggle.classList.add('active');
        this.searchInput.value = '';
        this.searchInput.focus();
        this.searchResults.classList.remove('open');
      } else {
        this.closeSearch();
      }
    }

    closeSearch() {
      if (!this.searchContainer) return;
      this.searchContainer.classList.add('hidden');
      this.searchToggle.classList.remove('active');
      this.searchResults.classList.remove('open');
    }

    handleSearch() {
      const query = this.searchInput.value.trim().toLowerCase();
      if (!query) {
        this.searchResults.classList.remove('open');
        return;
      }

      this.searchResults.innerHTML = '';
      const variants = window.productVariants;
      let count = 0;

      for (const [id, v] of Object.entries(variants)) {
        if (!v.available) continue;
        if (v.title.toLowerCase().includes(query)) {
          const div = document.createElement('div');
          div.className = 'variant-search-result';
          div.innerHTML = `${v.title} <span class="result-price">${v.price}</span>`;
          div.addEventListener('click', () => {
            this.variantSelect.value = id;
            this.handleVariantChange(id);
            this.closeSearch();
          });
          this.searchResults.appendChild(div);
          count++;
          if (count >= 20) break;
        }
      }

      this.searchResults.classList.toggle('open', count > 0);
    }

    resetToAllImages() {
      // Show "Select a color" and hide "See all colors" option
      if (this.selectColorOption) {
        this.selectColorOption.classList.remove('hidden');
        this.selectColorOption.style.display = 'block';
      }
      if (this.seeAllOption) {
        this.seeAllOption.classList.add('hidden');
        this.seeAllOption.style.display = 'none';
      }

      // Reset to "Select a color"
      this.variantSelect.value = '';

      // Disable add to cart button
      if (this.addToCartButton) {
        this.addToCartButton.disabled = true;
        this.addToCartButton.textContent = 'Add to Cart';
      }

      // Reset to price range
      if (this.priceElement) {
        const priceRangeHTML = this.priceElement.querySelector('.price-range');
        if (priceRangeHTML) {
          // Already has price range, just make sure it's visible
          this.priceElement.style.display = 'block';
        }
      }

      // Restore all product images
      if (this.variantImagesContainer && this.allProductImages.length > 0) {
        this.variantImagesContainer.innerHTML = '';
        this.allProductImages.forEach(img => {
          this.variantImagesContainer.insertAdjacentHTML('beforeend', img.html);
        });
      }
    }

    swapVariantImages(variantId) {
      if (!this.variantImagesContainer) return;

      const variant = window.productVariants[variantId];
      if (!variant) return;

      console.log('Swapping to variant:', variant.title);
      console.log('Variant has metafield images:', variant.metafieldImages);

      // Clear all existing images
      this.variantImagesContainer.innerHTML = '';

      // Add featured image if it exists
      if (variant.featuredImageId) {
        const featuredImage = window.productImages.find(img => img.id === variant.featuredImageId);
        if (featuredImage) {
          this.renderImage(featuredImage, variant.title, variantId);
        }
      } else if (variant.variantImageUrl) {
        // Fallback to variant_image metafield (file_reference)
        this.renderImage({
          url: variant.variantImageUrl,
          alt: variant.variantImageAlt || variant.title
        }, variant.title, variantId);
      }

      // Add swatch image from variant_swatch metafield
      if (variant.variantSwatchUrl) {
        this.renderImage({
          url: variant.variantSwatchUrl,
          alt: (variant.variantImageAlt || variant.title) + ' swatch'
        }, variant.title, variantId);
      }

      // Add metafield images if they exist
      if (variant.metafieldImages && variant.metafieldImages.length > 0) {
        variant.metafieldImages.forEach(image => {
          if (image.id === variant.featuredImageId) return;
          this.renderImage(image, variant.title, variantId);
        });
      }
    }

    renderImage(image, variantTitle, variantId) {
      const imageDiv = document.createElement('div');
      imageDiv.className = 'product-image';
      if (variantId) {
        imageDiv.dataset.variantId = variantId;
      }

      const img = document.createElement('img');
      img.src = image.url;
      img.alt = image.alt || variantTitle;
      img.loading = 'lazy';

      const label = document.createElement('div');
      label.className = 'product-image__label';
      label.textContent = variantTitle;

      imageDiv.appendChild(img);
      imageDiv.appendChild(label);

      // Add quick-add button if variant ID exists and variant is available
      if (variantId) {
        const variant = window.productVariants[variantId];
        if (variant && variant.available) {
          const quickAddBtn = document.createElement('button');
          quickAddBtn.className = 'product-image__quick-add';
          quickAddBtn.dataset.variantId = variantId;
          quickAddBtn.textContent = window.productTranslations.quickAdd;

          // Attach click handler
          quickAddBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            // Find the ImageQuickAdd instance and call its handler
            // Or call the handler directly
            this.handleImageQuickAdd(quickAddBtn);
          });

          imageDiv.appendChild(quickAddBtn);
        }
      }

      this.variantImagesContainer.appendChild(imageDiv);
    }

    async handleImageQuickAdd(button) {
      const variantId = button.dataset.variantId;

      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Check if this button is already processing a request
      if (this.processingButtons.has(variantId)) {
        console.log('[Cart] Request already in progress for variant:', variantId);
        return;
      }

      // Mark this button as processing
      this.processingButtons.add(variantId);

      const originalText = button.textContent;
      button.disabled = true;
      button.classList.add('loading');
      button.textContent = window.productTranslations.adding;

      try {
        // First, get current cart to check if item already exists
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // Find if this variant is already in cart
        const existingItem = cart.items.find(item => item.variant_id === parseInt(variantId));

        let response;
        if (existingItem) {
          // Item exists, increment quantity using change endpoint
          response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: existingItem.quantity + 1
            })
          });
        } else {
          // Item doesn't exist, add it
          response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId),
                quantity: 1
              }]
            })
          });
        }

        if (!response.ok) {
          const errorData = await response.json();
          console.error('[Cart] Failed to add variant:', {
            variantId,
            status: response.status,
            error: errorData
          });
          throw new Error(errorData.description || errorData.message || 'Failed to add to cart');
        }

        const data = await response.json();
        console.log('[Cart] Successfully added variant:', variantId);

        button.classList.remove('loading');
        button.classList.add('added');
        button.textContent = window.productTranslations.added;

        // Update cart count in header
        updateCartCount();

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        setTimeout(() => {
          button.classList.remove('added');
          button.textContent = originalText;
          button.disabled = false;
          // Remove from processing set
          this.processingButtons.delete(variantId);
        }, 2000);

      } catch (error) {
        console.error('[Cart] Error adding variant to cart:', {
          variantId,
          error: error.message
        });

        button.classList.remove('loading');

        // Check for specific error messages
        const errorMessage = error.message.toLowerCase();
        if (errorMessage.includes('availability') || errorMessage.includes('stock') || errorMessage.includes('inventory')) {
          button.textContent = window.productTranslations.noMoreStock;
        } else if (errorMessage.includes('quantity') || errorMessage.includes('limit') || errorMessage.includes('maximum')) {
          button.textContent = window.productTranslations.maxQuantity;
        } else {
          button.textContent = window.productTranslations.error;
        }

        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          // Remove from processing set
          this.processingButtons.delete(variantId);
        }, 2000);
      }
    }
  }

  // Quick Add functionality for product images
  class ImageQuickAdd {
    constructor() {
      this.processingButtons = new Set(); // Track which buttons are currently processing
      this.initQuickAddButtons();
    }

    initQuickAddButtons() {
      // Add event listeners to all current quick-add buttons
      const buttons = document.querySelectorAll('.product-image__quick-add');
      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.handleQuickAdd(e.currentTarget);
        });
      });
    }

    async handleQuickAdd(button) {
      const variantId = button.dataset.variantId;

      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Check if this button is already processing a request
      if (this.processingButtons.has(variantId)) {
        console.log('[Cart] Request already in progress for variant:', variantId);
        return;
      }

      // Mark this button as processing
      this.processingButtons.add(variantId);

      // Update button state to loading
      const originalText = button.textContent;
      button.disabled = true;
      button.classList.add('loading');
      button.textContent = window.productTranslations.adding;

      try {
        // First, get current cart to check if item already exists
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // Find if this variant is already in cart
        const existingItem = cart.items.find(item => item.variant_id === parseInt(variantId));

        let response;
        if (existingItem) {
          // Item exists, increment quantity using change endpoint
          response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: existingItem.quantity + 1
            })
          });
        } else {
          // Item doesn't exist, add it
          response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId),
                quantity: 1
              }]
            })
          });
        }

        if (!response.ok) {
          const errorData = await response.json();
          console.error('[Cart] Failed to add variant:', {
            variantId,
            status: response.status,
            error: errorData
          });
          throw new Error(errorData.description || errorData.message || 'Failed to add to cart');
        }

        const data = await response.json();
        console.log('[Cart] Successfully added variant:', variantId);

        // Show success feedback
        button.classList.remove('loading');
        button.classList.add('added');
        button.textContent = window.productTranslations.added;

        // Update cart count in header
        updateCartCount();

        // Trigger cart update event for cart drawer/icon
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        // Reset button after 2 seconds
        setTimeout(() => {
          button.classList.remove('added');
          button.textContent = originalText;
          button.disabled = false;
          // Remove from processing set
          this.processingButtons.delete(variantId);
        }, 2000);

      } catch (error) {
        console.error('[Cart] Error adding variant to cart:', {
          variantId,
          error: error.message
        });

        // Show error feedback
        button.classList.remove('loading');

        // Check for specific error messages
        const errorMessage = error.message.toLowerCase();
        if (errorMessage.includes('availability') || errorMessage.includes('stock') || errorMessage.includes('inventory')) {
          button.textContent = window.productTranslations.noMoreStock;
        } else if (errorMessage.includes('quantity') || errorMessage.includes('limit') || errorMessage.includes('maximum')) {
          button.textContent = window.productTranslations.maxQuantity;
        } else {
          button.textContent = window.productTranslations.error;
        }

        // Reset button after 2 seconds
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          // Remove from processing set
          this.processingButtons.delete(variantId);
        }, 2000);
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new MegaVariantSelector();
      new ImageQuickAdd();
    });
  } else {
    new MegaVariantSelector();
    new ImageQuickAdd();
  }

  } catch(e) { console.error(e); }
})();
})();
